import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tree } from "../custom-components/tree-view-component";
import { Module, QueryKeys } from "../models/models";
import { TreeNode } from "../models/tree-models";
import { useQuery, useStore } from "../stores/store";
import { getChildren, getParents, GetSubElements, useSideBarStyles } from "./side-bar";
import { getSortedData } from "./app-container-components/configure-formula";
import { NavLink } from "@mantine/core";
import { supportedModules } from "../stores/constants";

export const ViewSideBar = observer(function FormulaEditor({ treeView, onIconClick }: { treeView: boolean; onIconClick: () => void }) {
  const { store } = useStore();
  const [data, setData] = useState<TreeNode[]>([]);
  const params = useParams<{ id: string; parent: string }>();
  const navigateTo = useNavigate();
  const [selectedModule, setSelectedModule] = useState<string>(params.id ?? "");
  const { classes } = useSideBarStyles();

  const { data: modules } = useQuery({
    queryKey: [QueryKeys.Modules],
    queryFn: async () => {
      return await store.GetAllModules();
    },
  });

  useEffect(() => {
    let allModules = modules ?? [];
    allModules = getSortedData(
      allModules?.find((m) => m.parentId === 0)?.moduleConfig?.modulesOrder?.map((m) => m.toString()) ?? [],
      allModules ?? []
    ) as Module[];
    if (params.parent != null) {
      const parentId = allModules.find((d) => d.name === params.parent)?.id;
      allModules = parentId != null ? GetSubElements(allModules, parentId) : [];
    }
    transFormData(allModules);
  }, [JSON.stringify(modules), params.parent]);
  const transFormData = (moduleTreeData: Module[]) => {
    const parents = getParents(moduleTreeData);
    const transformedData = parents.map((pd) => {
      const cData = getChildren(moduleTreeData, Number(pd.id));
      return { ...pd, children: cData };
    });
    setData(transformedData);
  };

  const renderHighLevelIcons = (module: TreeNode) => {
    return (
      <NavLink
        className={classes.collapsedSideBarLink}
        variant="filled"
        label={<img className={classes.collapsedSideBarIcons} src={supportedModules.find((sm) => sm.title === params.parent)?.img} alt={`${params.parent}`} />}
        key={params.id}
        active={params.id === selectedModule}
        onClick={() => {
          onIconClick();
          setSelectedModule(module.id);
          navigateTo(`/view/${params.parent}/${module.id}`);
        }}
      />
    );
  };

  return (
    <>
      {treeView ? (
        <Tree
          data={data}
          value={params.id ?? ""}
          onSelect={(value) => {
            if (params.parent == null) return;
            navigateTo(`/view/${params.parent}/${value}`);
          }}
          onChange={(e) => {
            setData(e);
          }}
          defaultExpandedNodes={"all"}
        />
      ) : (
        renderHighLevelIcons(data[0])
      )}
    </>
  );
});
